import React from "react"
import { createElement } from "./../utils/create-elements"

const lkfNews = ({ blok }) => <>{createElement(blok)}</>

export default lkfNews
